// extracted by mini-css-extract-plugin
export default {"headingContainer":"ZVDYYC","questionContainer":"J9dHMp"};